import React, { useState, useEffect } from 'react';
import './Categories.css';
import { useNavigation } from '../../../shared/utils/useNavigation';
import { formatProfileTag, isUserLoggedIn } from "../../../shared/utils/function";
import { fetchCategoriesWithCount } from "../../../shared/actions/categoryAction";
import { reportError } from "../../../shared/sentry";

const CategoryLists = () => {
  const navigate = useNavigation();
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  // Fetch categories on mount
  useEffect(() => {
    fetchCategories();
  }, []);

  // Fetch categories from API
  const fetchCategories = async () => {
    setLoadingCategories(true);
    
    try {
      const isGuest = !isUserLoggedIn();
      const response = await fetchCategoriesWithCount(isGuest);
      
      if (response.success && response.data) {
        const categoriesData = response.data
          .filter(category => category.count > 0) // Hide categories with 0 creators
          .map(category => ({
            id: category.category.toLowerCase(),
            name: category.category.toLowerCase(),
            creators: category.count >= 1000 
              ? `${(category.count / 1000).toFixed(1)}K` 
              : category.count.toString()
          }));
        setCategories(categoriesData);
      }
    } catch (error) {
      reportError(error, 'CategoryLists fetch categories');
    } finally {
      setLoadingCategories(false);
    }
  };

  const getCategoryColorClass = (index) => {
    const colors = ["red", "blue", "green", "purple"];
    return colors[index % colors.length];
  };

  const handleCategoryClick = (categoryName) => {
    navigate.toAllCreators(categoryName);
  };

  // Only render if there are categories or still loading
  if (!loadingCategories && categories.length === 0) {
    return null;
  }

  return (
    <div id="featured-section" className="featured-section">
      <div className="featured-section-header" id="CategoriesHeadline">
        <h3 className="featured-section-title">Categories</h3>
      </div>
      <div className="categories-scroll-new">
        {loadingCategories ? (
          <div className="loading-categories">Loading categories...</div>
        ) : (
          categories.map((category, index) => (
            <div 
              onClick={() => handleCategoryClick(category.name)} 
              key={category.id || index} 
              className={`category-card ${getCategoryColorClass(index)}`}
            >
              <span className="category-card-name">
                {formatProfileTag(category.name)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CategoryLists;

